import * as escapeStringRegexp from 'escape-string-regexp';
import * as $ from 'jquery';
import { escape as sanitizeEscape } from 'lodash';

export default class TextHighlight {
  static NAMESPACE = 'axel-text-highlight';

  private opts;
  public label;
  private renderer;
  private $container;
  private searchTree = {};

  constructor(renderer, opts) {
    this.renderer = renderer;
    this.opts = opts;
    this.label = 'text-highlight';

    this.wrapCellLayout(renderer);
  }

  /**
   * [HookMethod] Data
   * @param data
   * @returns {any}
   */
  public data(data) {
    this.searchTree = this.generateSearchTree(data.tree, data.rows(), data.cols());
    return data;
  }

  /**
   * [HookMethod] Build Table
   * @param tableEl
   * @param containerEl
   * @returns {any}
   */
  public buildTable(tableEl, containerEl) {
    this.$container = $(containerEl);

    $(tableEl).addClass(TextHighlight.NAMESPACE);
    return tableEl;
  }

  /**
   * Generate Search Tree
   *
   * Walks the data tree and generates a search hit index of all
   * rows that contain target querystring/pattern
   *
   * @todo consolidate search methods. it's not DRY to search here and in the model
   *       {@see straightModel.rowContains}
   * @param tree
   * @param rowKeys
   * @param colKeys
   * @returns {Array}
   */
  private generateSearchTree(tree, rowKeys, colKeys) {
    const qs = this.getQueryString();
    const pattern = RegExp(escapeStringRegexp(qs.toString()), 'i');
    const results = [];
    const walkTree = (tree, rows, cols, callback) => {
      for (const rowKey of rows) {
        for (const colKey of cols) {
          callback.call(null, tree[rowKey][colKey], rowKey, colKey, tree);
        }
      }
    };
    const updateTree = (tree, x, y, val) => {
      tree[x] = tree[x] || {};
      tree[x][y] = tree[x][y] || {};
      tree[x][y] = val;
    };
    const search = (pattern, resultsTree) => (val, rowKey, colKey) => {
      const index = val.format().search(pattern);

      if (index >= 0) {
        updateTree(resultsTree, rowKey, colKey, index);
      }
    };

    if (qs && qs.length && qs.length > this.minQueryLength()) {
      walkTree(tree, rowKeys, colKeys, search(pattern, results));
    }
    return results;
  }

  private getQueryString() {
    return this.opts.pattern || '';
  }

  private minQueryLength() {
    return this.opts.minQueryLength || 2;
  }

  private wrapCellLayout(tableRenderer) {
    const superCellLayout = tableRenderer.buildCell();
    const rowKeys = this.renderer.data().rows();
    const colKeys = this.renderer.data().cols();
    const queryLength = this.getQueryString().length;

    tableRenderer.buildCell((...args) => {
      const cellElem = superCellLayout.apply(null, [...args]);
      const [value, attr, type] = args;
      const colIndex = attr.data.column;
      const rowIndex = attr.data.row;
      const rowKey = rowKeys[rowIndex - 1];
      const colKey = colKeys[colIndex - 1];

      if (this.searchTree[rowKey] && !isNaN(parseInt(this.searchTree[rowKey][colKey]))) {
        const index = this.searchTree[rowKey][colKey];

        // replace content with highlighted content
        cellElem.innerHTML = [
          sanitizeEscape(value.substring(0, index)),
          "<span class='highlight'>",
          sanitizeEscape(value.substring(index, index + queryLength)),
          '</span>',
          sanitizeEscape(value.substring(index + queryLength)),
        ].join('');
      }
      return cellElem;
    });
  }
}
